<template>
  <div v-if="!showDettaglio">
    <h3 class="info-center">Stampante Fiscale</h3>
    <h4 class="info-center red blink" v-if="infoStampante.errore">{{infoStampante.errore}}</h4>
    <h4 class="info-center orange blink" v-if="infoStampante.lowDGFE">Attenzione spazio DGFE minore del 10%. <br/>Contattare l'assistenza </h4>
    <van-row type="flex" justify="space-around">
      <van-col span="10">
        <van-cell-group>
          <van-cell title="Matricola" :value="infoStampante.matricola" />
          <van-cell title="Firmware" :value="infoStampante.firmware" />
          <van-cell title="Spazio libero DGFE" :value="infoStampante.liberoDGFE" />
          <van-cell title="Data/ora" :value="infoStampante.data"/>
          <van-button v-if="mostraTutto || (mostraAggiornaOra && !mostraCambioModo)" type="info" plain size="large" @click="aggiornaOra">Aggiorna ora Stampante</van-button>
          <van-cell title="Ultimo azzeramento" :value="infoStampante.lastZ" />
          <van-cell title="Ultimo documento" :value="infoStampante.lastDocF" />
        </van-cell-group>
      </van-col>
      <van-col span="10">
        <van-cell-group>
          <van-cell title="File pendenti" :value="infoStampante.filePendenti"/>
          <van-cell v-if="mostraTutto || infoStampante.oldFile" title="File più vecchio" :value="infoStampante.oldFile"/>
          <van-button v-if="mostraTutto || mostraInvioPendenti" type="primary" plain size="large" @click="invioPendenti">Invia file pendenti</van-button>
          <van-cell title="Modo" :value="infoStampante.modo" />
          <van-button v-if="mostraTutto || mostraCambioModo" type="primary" plain size="large" @click="modoReg">Passa a modo REG</van-button>
          <van-cell title="Stato" :value="infoStampante.stato" :value-class="classeInattiva" :title-class="classeInattiva"  size="large"/>
          <van-button v-if="mostraTutto || (mostraCambioStato && !mostraCambioModo)" type="warning" plain size="large" @click="eseguiChiusura">Chiusura giornaliera</van-button>
          <van-cell title="Indirizzo IP" :value="infoStampante.ipStampante" />
          <div class="test-stampante">
            <van-button plain small type="primary" style="margin-right: 10px;" @click="testStampante()">Test Stampante</van-button>
          </div>
        </van-cell-group>
      </van-col>
    </van-row>
<!--     <div class="test-stampante">
      <van-button plain small type="primary" style="margin-right: 10px;" @click="testStampante()">Test Stampante</van-button>
    </div> -->
  </div>
</template>

<script>
// import configurazioni from '@/services/configurazioniService'
import stampante from '@/services/stampanteService'
import rch from '../stampanti/rch'
import epson from '../stampanti/epson'
import ditron from '../stampanti/ditron'

export default {
  props: {
    showDettaglio: Boolean,
    richiestaChiusura: Boolean,
    numStampante: Number,
    context: Object
  },
  data() {
    return {
      printerStatus: null,
      infoStampante: {},
      infoStampanteMA: [],
      activeName: null,
      testInterval: null,
      mostraTutto: false,
      tipoDriver: 'RCH-PF',
      printers: {
        'RCH-PF': rch,
        EPSON: epson,
        DITRON: ditron
      },
      richiestaStato: false,
      timerChiudi: null,
      erroreAllineamento: false
    }
  },
  watch: {
    richiestaChiusura(value) {
      if (value) {
        if (!this.infoStampante.errore || this.infoStampante.errCode === 'STATUS_ERROR') {
          this.modoReg()
          console.log('richiestaChiusura', this.testInterval)
          clearInterval(this.testInterval)
          this.testInterval = null
          // setTimeout(() => { this.context.inviaBenvenutoAMF = true }, 500)
        }
      }
    }
  },
  async mounted() {
    await this.onOpen()
    /*     this.testInterval = setInterval(async () => {
      await this.getInfoStampante()
    }, 4000) */
  },
  computed: {
    visibilita() {
      return {
        mostraCambioModo: this.mostraCambioModo,
        mostraCambioStato: this.mostraCambioStato,
        mostraAggiornaOra: this.mostraAggiornaOra,
        mostraInvioPendenti: this.mostraInvioPendenti,
        classeInattiva: this.classeInattiva,
        mostraTutto: this.mostraTutto
      }
    },
    mostraCambioModo() {
      const hnd = this.printers[this.tipoDriver]
      return hnd.mostraCambioModo(this.infoStampante)
    },
    mostraCambioStato() {
      const hnd = this.printers[this.tipoDriver]
      return hnd.mostraCambioStato(this.infoStampante)
    },
    mostraAggiornaOra() {
      const hnd = this.printers[this.tipoDriver]
      return hnd.mostraAggiornaOra(this.printerStatus)
    },
    mostraInvioPendenti() {
      return false
    },
    classeInattiva() {
      return this.mostraCambioStato ? 'testo-inattiva blink' : ''
    },
    hnd() {
      return this.printers[this.tipoDriver]
    },
    statoServizi() {
      return this.$store.getters.serviceStatus
    },
    bloccaChiusura() {
      let blocca = false
      for (const s of this.statoServizi) {
        if (!s.health || s.health === '---') {
          blocca = true
        }
      }
      return blocca
    }
  },
  beforeDestroy () {
    if (this.testInterval) {
      console.log('beforeDestroy', this.testInterval)
      clearInterval(this.testInterval)
    } else {
      console.log('beforeDestroy: null')
    }
  },
  methods: {
    /*     aggiornaOra() {
      this.$emit('eventi', { tipo: 'aggiornaOra' })
    },
    invioPendenti() {
      this.$emit('eventi', { tipo: 'invioPendenti' })
    },
    modoReg() {
      this.$emit('eventi', { tipo: 'modoReg' })
    },
    eseguiChiusura() {
      this.$emit('eventi', { tipo: 'eseguiChiusura' })
    },
    testStampante() {
      this.$emit('eventi', { tipo: 'testStampante' })
    }, */
    async getInfoStampante() {
      if (this.context.chiusuraGiornalieraInCorso) return
      if (this.richiestaStato) return
      this.richiestaStato = true
      console.log('getInfoStampante: ', this.numStampante)
      this.printerStatus = await stampante.printerStatus(this.numStampante)
      this.richiestaStato = false
      this.tipoDriver = this.printerStatus.tipoDriver || 'RCH-PF' // per compatibilità
      // Verificare uso plugin per nuove stampanti !!!
      const hnd = this.printers[this.tipoDriver]
      this.infoStampante = hnd.infoStampante(this.printerStatus)
    },
    async onOpen() {
      this.testInterval = setInterval(async () => {
        await this.getInfoStampante()
      }, 4000)
      await this.getInfoStampante()
    },
    eseguiChiusura() {
      this.fermaTimerChiudi()
      const event = {
        type: 'FUNZIONE_RAPIDA_CONFIRM',
        value: {
          funzione: 'CHIUSURA_GIORNALIERA',
          confirm: true
        }
      }
      this.$emit('send-event', event)
      this.avviaTimerChiudi(100000)
    },
    async aggiornaOra() {
      if (!this.hnd.aggiornaOraPossibile(this.printerStatus)) {
      // if (this.request.lastDocF !== '0') {
        await this.$dialog.alert({
          title: 'Aggiornamento ora stampante',
          message: 'Prima di poter aggiornare l\'ora è necessario effettuare manualmente una chiusura fiscale'
        })
        return
      }
      await stampante.setPrinterDate()
    },
    modoReg() {
      // const hnd = this.printers[this.tipoDriver]
      // hnd.passaModoReg()
      const event = {
        type: 'PRINTER',
        value: {
          // commands: ['=C1'] // PASSA_MODO_REG
          commands: ['PASSA_MODO_REG'] // PASSA_MODO_REG
        }
      }
      this.$emit('send-event', event)
    },
    invioPendenti() {

    },
    async testStampante() {
      const scontrinoInfo = [
        'Test stampante'
      ]
      await stampante.stampaScontrinoGestionale(scontrinoInfo, '', this.numStampante)
    }
  }
}
</script>

<style lang="scss" scoped>
  .popup-stampante {
    width: 40vw;
    height: 60vh; /* 47 Attenzione lasciare spazio per pulsanti aggiornamento */
  }

  @media all and (max-width: 1800px) {
    .popup-stampante {
      width: 50vw;
      height: 67vh;
    }
  }

  @media all and (max-width: 1400px) {
    .popup-stampante {
      width: 55vw;
      height: 72vh; /* 52 Attenzione lasciare spazio per pulsanti aggiornamento */
    }
  }

  @media all and (max-width: 1024px) {
    .popup-stampante {
      width: 80vw;
      height: 72vh; /* 52 Attenzione lasciare spazio per pulsanti aggiornamento */
    }
  }

  .info-center {
    text-align: center;
    &.red {
      color: red;
    }
    &.orange {
      color: #ff8800;
    }
  }
  .testo-inattiva {
    color: red;
    font-weight: bold;
  }
  .popup-stampante .van-cell {
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .blink {
    animation: blinker 1s step-start infinite;
  }

  @keyframes blinker {
    50% {
      opacity: 0;
    }
  }

  .test-stampante {
    position: absolute;
    /* bottom: -100px; */
    left: auto;
    right: 0px;
    padding-top: 20px;
    &.fatture {
      bottom: 36vh;
    }
  }
</style>
